module.exports = __webpack_public_path__ + "static/media/Octo-logo.568fcf3d.png";